module.exports = __webpack_public_path__ + "img/le-plus-beau-jour.55773496.jpg";